import React, { ReactNode } from 'react';

const PrimaryButton = ({
  label,
  onClick,
  disabled,
  className,
}: {
  label: string | ReactNode;
  onClick: (e) => void;
  disabled?: boolean;
  className?: string;
}) => (
  <button
    className={`px-4 py-2  ${className ? className : ''} ${
      disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-slate-900 text-white hover:bg-slate-800 '
    } inline-flex items-center text-sm justify-center howio-font-md rounded-lg `}
    onClick={onClick}
    disabled={disabled}
  >
    <div>{label}</div>
  </button>
);

export default PrimaryButton;
